/*
 * Delete-discount.ts
 * Description: Includes the declaration
 * of the function for deleting a discount
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting a discount
 *
 * @return {Object} Promise - when the request has been fulfilled
 * @param {Number} id - id of the discount
 * @param {String} slug - slug of the restaurant
 */
export function deleteDiscount(id: number, slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/discounts/' + id,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
